import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class PeerConnectionError extends BaseError {
    constructor(message: string, loggerFields: SafeLogErrorOptions, stack?: string) {
        super(
            message,
            {
                source: 'backend',
                block: 'webrtc',
                ...loggerFields,
            },
            stack
        );

        Object.setPrototypeOf(this, PeerConnectionError.prototype);
    }
}
